<template>
 <div>
  testt
  {{array[1]}}
  <div id="map"></div>
  </div>
</template>

<script>
  var map;
  var marker = new longdo.Marker({ lon: 100.643005, lat: 14.525007 })
  // var ma = this
export default {
  data () {
    return {
      locationList: [],
      array: []
    }
  },
  created () {
    this.init3()
  },
  mounted () {
    this.init()
  },
  methods: {
    init2 () {
      var a = '["sunday","saturay"]'
      a = a.replace(/'/g, '"')
      this.array = JSON.parse(a)
    },
    init3 () {
      this.axios.get('http://203.151.119.194:9100/api/v1/getAllAed').then((response) => {
        console.log(response.data)
        this.locationList = response.data.data
      }, (error) => {
        console.log(error)
      })

    },
    init () {
      console.log('test')
      // init() {
      map = new longdo.Map({
        placeholder: document.getElementById('map')
      });
      var me = this

      map.Tags.add(function(tile, zoom) {
        var bound = longdo.Util.boundOfTile(map.projection(), tile);
        // me.mockAjaxFromServer(bound, function(locationList) {
        for (var i = 0; i < me.locationList.length; ++i) {
          map.Overlays.add(new longdo.Marker({lon: me.locationList[i].location.longitude, lat: me.locationList[i].location.latitude}, { visibleRange: { min: zoom, max: zoom } }));
        }
        // });
      });
    }
  }
}
</script>

<style scoped>
#map {
            height: 50vh;

          }
</style>



// WEBPACK FOOTER //
// src/components/testMap.vue